<template>
  <div class="inner-page tariff-page">
    <header-on-slots>
      <template v-slot:menu-button>
        <button v-if="!editMode" type="button" class="menu-button" @click.stop="onCloseMenu">
          <span>Меню</span>
        </button>
        <button v-if="editMode" type="button" class="menu-button back-click" @click.stop="onDisableEditMode">
          <span>Назад</span>
        </button>
      </template>
      <template v-slot:header-title>
        <div class="header-title">
          <template v-if="!editMode">
            <div class="main-title">Тарифы Регионального оператора</div>
          </template>
          <template v-if="editMode">
            <div class="up-title">Тарифы Регионального оператора</div>
            <div class="main-title">Тариф</div>
          </template>
        </div>
        <i class="spacer" />
      </template>
      <template v-slot:header-buttons>
        <div v-if="isAuthorized" class="header-buttons">
          <regular-button v-if="editMode" type="button" :rounded="true" class="save-button" @click.stop="onClickSaveObject">
            сохранить
          </regular-button>
          <regular-button v-if="editMode" type="button" :blank="true" class="cancel-button" @click.stop="onDisableEditMode">
            отмена
          </regular-button>
        </div>
      </template>
    </header-on-slots>

    <main-nav-menu :is-menu-active="isMenuActive" @close-menu="onCloseMenu" />

    <router-view />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";

import HeaderOnSlots from "../../../components/HeaderOnSlots";
import MainNavMenu from "../../../components/MainNavMenu";
import RegularButton from "../../../components/RegularButton";
import { nprogressMixin } from "../../../mixins";

export default {
  name: "Tariff",
  components: {
    HeaderOnSlots,
    MainNavMenu,
    RegularButton
  },
  mixins: [nprogressMixin],
  data() {
    return {
      isMenuActive: false
    };
  },
  computed: {
    ...mapState(["isAuthorized"]),
    ...mapState("tariff", ["tariffData", "editMode", "fieldRequires", "editObject"])
  },
  beforeDestroy() {
    axios.cancel("analitics-tariff");

    this.setTariffData({
      count: 0,
      results: []
    });
  },
  methods: {
    ...mapActions(["transactionRequest"]),
    ...mapActions("tariff", ["getTariffData", "addNewObject", "updateObject", "cancelEditing"]),
    ...mapMutations("hashManager", ["updateRouteOptions"]),
    ...mapMutations("tariff", [
      "setUploadData",
      "setEditMode",
      "updateValidationErrorsField",
      "updateServerErrorsField",
      "updateErrorsInfosField",
      "setTariffData"
    ]),
    onCloseMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    // Валидация полей
    hasInvalidFields() {
      const requires = this.fieldRequires.reduce((requires, field) => {
        if (
          ["flows_total_distance", "flows_total_waste_volume", "transportation_cost"].includes(field) &&
          !this.editObject.manual_calculation
        ) {
          return requires;
        }

        const value = this.editObject[field];
        if (typeof value === "undefined" || value === null) {
          this.updateValidationErrorsField({ fieldName: field, newFieldValue: true });

          // if (
          //   field === "transportation_waste_volume" &&
          //   typeof this.editObject.transportation_waste_weight !== "undefined" &&
          //   this.editObject.transportation_waste_weight !== null
          // ) {
          //   this.updateValidationErrorsField({ fieldName: "transportation_waste_weight", newFieldValue: false });
          //   const index = requires.indexOf("transportation_waste_weight");
          //   if (index !== -1) {
          //     return [...requires.slice(index, 1), field];
          //   }
          // } else if (
          //   field === "transportation_waste_weight" &&
          //   typeof this.editObject.transportation_waste_volume !== "undefined" &&
          //   this.editObject.transportation_waste_volume !== null
          // ) {
          //   this.updateValidationErrorsField({ fieldName: "transportation_waste_volume", newFieldValue: false });
          //   const index = requires.indexOf("transportation_waste_volume");
          //   if (index !== -1) {
          //     return [...requires.slice(index, 1), field];
          //   }
          // }

          return [...requires, field];
        }
        return requires;
      }, []);
      return requires.length > 0 || false;
    },
    onDisableEditMode() {
      this.cancelEditing();

      axios.cancel("analitics-tariff");
      this.setUploadData(true);

      this.getTariffData().then(() => {
        this.$router.push({
          name: "TariffTable"
        });
        this.setUploadData(false);
      });
    },
    onClickSaveObject() {
      if (this.hasInvalidFields()) {
        return;
      }

      const data = {
        ...this.editObject
      };

      if (!this.editObject.manual_calculation) {
        delete data.flows_total_distance;
        delete data.flows_total_waste_volume;
        delete data.transportation_cost;
      }

      this.setUploadData(true);

      if (this.editObject.id === "new") {
        this.addNewObject(data).then(response => {
          if (response.status === 201) {
            this.getTariffData().then(response => {
              if (response && response.status && response.status == 200 && response.data) {
                this.resetCurrentPage();
                this.setUploadData(false);
                this.onDisableEditMode();
              } else {
                if (axios.isCancel(response) && !axios.hasOpenRequest("analitics-tariff")) {
                  this.setUploadData(false);
                  this.onDisableEditMode();
                }
              }
            });
          } else if (response.status === 400) {
            if (typeof response.data === "object" && Object.keys(response.data).length > 0) {
              Object.keys(response.data).map(errorField => {
                this.updateErrorsInfosField({ fieldName: errorField, newFieldValue: response.data[errorField][0] });
                this.updateServerErrorsField({ fieldName: errorField, newFieldValue: true });
              });
            }
            this.setUploadData(false);
          }
        });
      } else {
        this.updateObject({ data, id: this.editObject.id }).then(response => {
          if (response.status === 200) {
            this.getTariffData().then(response => {
              if (response && response.status && response.status == 200 && response.data) {
                this.setUploadData(false);
                this.onDisableEditMode();
              } else {
                if (axios.isCancel(response) && !axios.hasOpenRequest("analitics-tariff")) {
                  this.setUploadData(false);
                  this.onDisableEditMode();
                }
              }
            });
          } else if (response.status === 400) {
            if (typeof response.data === "object" && Object.keys(response.data).length > 0) {
              Object.keys(response.data).map(errorField => {
                this.updateErrorsInfosField({ fieldName: errorField, newFieldValue: response.data[errorField][0] });
                this.updateServerErrorsField({ fieldName: errorField, newFieldValue: true });
              });
            }
            this.setUploadData(false);
          }
        });
      }
    },
    resetCurrentPage() {
      this.updateRouteOptions({
        route: this.$route,
        options: {
          page: 1
        }
      });
    }
  }
};
</script>
